import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "modal-wrapper" }
const _hoisted_2 = { class: "input-row" }
const _hoisted_3 = { class: "input-wr input-price-wr" }
const _hoisted_4 = { class: "initial-deposit-wrapper" }
const _hoisted_5 = { class: "input-row" }
const _hoisted_6 = { class: "toggle-block toggle-title-bold" }
const _hoisted_7 = {
  key: 0,
  class: "toggle-description"
}
const _hoisted_8 = {
  key: 1,
  class: "toggle-description"
}
const _hoisted_9 = {
  key: 2,
  class: "deposit-amount"
}
const _hoisted_10 = {
  key: 1,
  class: "error-hint"
}
const _hoisted_11 = {
  key: 0,
  class: "input-row refundable"
}
const _hoisted_12 = { class: "toggle-block" }
const _hoisted_13 = {
  key: 0,
  class: "toggle-description"
}
const _hoisted_14 = ["disabled"]
const _hoisted_15 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_tippy = _resolveDirective("tippy")!

  return (_openBlock(), _createBlock($setup["Modal"], {
    isOpen: $props.isOpen,
    showClose: true,
    onClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('close')))
  }, _createSlots({ _: 2 }, [
    (!$setup.loading)
      ? {
          name: "content",
          fn: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _cache[8] || (_cache[8] = _createElementVNode("div", { class: "modal-title" }, "Initial deposit settings", -1)),
              _createElementVNode("form", {
                class: "default-form",
                onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"]))
              }, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                          _withDirectives(_createVNode($setup["ToggleButton"], {
                            modelValue: $setup.initDepositCondition,
                            "onUpdate:modelValue": [
                              _cache[0] || (_cache[0] = ($event: any) => (($setup.initDepositCondition) = $event)),
                              $setup.setDepositAndRefundable
                            ],
                            disabled: !$setup.isTrustAccountConnected,
                            additionalClass: 'large',
                            labelBold: 'toggle-title-font',
                            label: "Initial deposit"
                          }, null, 8, ["modelValue", "disabled"]), [
                            [_directive_tippy, { content: !$setup.isTrustAccountConnected ? $setup.tooltipText : '', theme: 'light-border', placement: 'bottom' }]
                          ]),
                          ($setup.initDepositCondition)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_7, "Buyers will be required to pay an initial holding deposit when completing a Contract information form."))
                            : (_openBlock(), _createElementBlock("div", _hoisted_8, "Buyers will not be required to pay an initial holding deposit when completing a Contract information form.")),
                          ($setup.initDepositCondition)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_9, "Deposit amount"))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    ($setup.initDepositCondition)
                      ? (_openBlock(), _createBlock($setup["Cleave"], {
                          key: 0,
                          class: _normalizeClass(["input deposit", [{ error: $setup.v$.initDeposit.$error }]]),
                          id: "deposit",
                          modelValue: $setup.form.initDeposit,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.form.initDeposit) = $event)),
                          modelModifiers: { trim: true },
                          type: "text",
                          placeholder: "Initial deposit",
                          options: $setup.initDepositOptions
                        }, null, 8, ["modelValue", "class"]))
                      : _createCommentVNode("", true),
                    ($setup.v$.initDeposit.$error)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString($setup.v$.initDeposit.$errors[0].$message), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                ($setup.initDepositCondition)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createVNode($setup["ToggleButton"], {
                          modelValue: $setup.form.isRefundable,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.form.isRefundable) = $event)),
                          additionalClass: 'large',
                          labelBold: 'toggle-title-font',
                          label: "Refundable"
                        }, null, 8, ["modelValue"]),
                        ($setup.initDepositCondition)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                              _cache[6] || (_cache[6] = _createTextVNode("Buyers will be notified before submitting a Contract information", -1)),
                              _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1)),
                              _createTextVNode(" form that the holding deposit is " + _toDisplayString(`${$setup.form.isRefundable ? "" : " not"} refundable.`), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ], 32),
              _createElementVNode("div", {
                class: _normalizeClass(["controls", { 'disabled-block ': $setup.disabled }])
              }, [
                _createElementVNode("button", {
                  class: "button default cancel",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('close'))),
                  disabled: $setup.disabled
                }, "Cancel", 8, _hoisted_14),
                _createElementVNode("button", {
                  class: "button default primary save",
                  onClick: $setup.save,
                  disabled: $setup.disabled
                }, "Save", 8, _hoisted_15)
              ], 2)
            ])
          ]),
          key: "0"
        }
      : {
          name: "content",
          fn: _withCtx(() => [
            _cache[9] || (_cache[9] = _createElementVNode("div", { class: "spinner" }, null, -1))
          ]),
          key: "1"
        }
  ]), 1032, ["isOpen"]))
}